import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { ValueBridgeGraphData } from '../value-bridge/sb-value-bridge.model';

export interface SbValueBridgeState {
    parentGraphData: ValueBridgeGraphData | null;
    childGraphData: ValueBridgeGraphData | null;
}

export function createInitialState(): SbValueBridgeState {
    return {
        parentGraphData: null,
        childGraphData: null
    };
}
/** @deprecated Re-adding just allow the legacy value bridge component to work. DO NOT USE ELSEWHERE! */
@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'valueBridge' })
export class SbValueBridgeStore extends Store<SbValueBridgeState> {
    constructor() {
        super(createInitialState());
    }

    updateParentGraphData(newGraphData: ValueBridgeGraphData) {
        this.update({ parentGraphData: newGraphData });
    }

    updateChildGraphData(newGraphData: ValueBridgeGraphData) {
        this.update({ childGraphData: newGraphData });
    }
}
